import { Row, Col } from "antd";
import React from "react";

QualityPolicyAndCertificates.defaultProps = {
  showCertificates: true
}

export default function QualityPolicyAndCertificates({innovativeIcon, competitivenessIcon, ethicalIcon, showCertificates}) {
  return (
    <div className="about-us">
      <Row className="quality-policy" gutter={[40, 40]} justify="center">
        <Col span={24}>
          <div className="section-header">
            <h2>Quality Policy</h2>
            <p>ICE Holidays is committed to strive towards our customer satisfaction by delivering value of money products and services. The Management and all employees are committed for continual improvement in our Quality Management System through effort in :-</p>
          </div>
        </Col>
        <Col xs={24} sm={24} lg={8}>
            <div className="items">
              {innovativeIcon}
              <label>Innovative</label>
              <p>Talented team to develop great products and services. Agile, innovative, and a quality conscious team of resourceful people dedicated to the best</p>
            </div>
        </Col>
        <Col xs={24} sm={24} lg={8}>
            <div className="items">
              {competitivenessIcon}
              <label>Competitiveness</label>
              <p>Provide competitive pricing to achieve customer satisfaction.</p>
            </div>
        </Col>
        <Col xs={24} sm={24} lg={8}>
            <div className="items">
              {ethicalIcon}
              <label>Ethical</label>
              <p>Precedent for an honest, fair and ethical business. Complying to our Quality Management System according to ISO 9001 requirements.</p>
            </div>
        </Col>
      </Row>

    {
      showCertificates == true && (
        <Row className="certificates" align="middle" justify="center" gutter={[24, 24]}>
          <Col span={24}>
            <div className="section-header">
              <h2>Our Certificates</h2>
              <p>We have acquired recognition and certificates such as:</p>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
              <img src="/iceholidays-assets/images/Motac2026.png"/>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} >
              <img src="/iceholidays-assets/images/ISOCertificate2026.png" alt="ISO Certificate 2026"/>
          </Col>
        </Row>
      )
    }
    </div>
  )
}